import { DASH_SLASH } from 'consts/placeholders';

import { CREATIVE_STATUS_BADGE } from 'consts/creative';
import StatusRenderer from 'components/common/StatusRenderer';
import { Size } from 'lib/Chip';
import { CreativeSetDetails } from 'components/common/types/Creative.types';
import DetailsItem from '../DetailsItem';

const CreativeDetails = ({ creativeDetails }: { creativeDetails: CreativeSetDetails }): React.ReactElement => {
  const { status, dsp, advertiser, brand } = creativeDetails;

  return (
    <div className="grid grid-cols-2 px-10 py-6 gap-5" data-test-id="creative-details-section">
      <DetailsItem
        label="Status"
        value={
          status ? (
            <StatusRenderer value={status} statuses={CREATIVE_STATUS_BADGE} chipSize={Size.MEDIUM} />
          ) : (
            DASH_SLASH
          )
        }
      />
      <DetailsItem label="DSP" value={dsp?.name || DASH_SLASH} />
      <DetailsItem label="Advertiser" value={advertiser?.name || DASH_SLASH} />
      <DetailsItem label="Brand" value={brand?.name || DASH_SLASH} />
    </div>
  );
};

export default CreativeDetails;
